import { render, staticRenderFns } from "./BCXCollapsible.vue?vue&type=template&id=26ddd05d&scoped=true"
import script from "./BCXCollapsible.vue?vue&type=script&lang=ts"
export * from "./BCXCollapsible.vue?vue&type=script&lang=ts"
import style0 from "./BCXCollapsible.vue?vue&type=style&index=0&id=26ddd05d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ddd05d",
  null
  
)

export default component.exports